module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"yyyy-MM-dd":"dd.MM.yyyy","New Event":"Neues Event","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Event list could not be fetched.":"Eventliste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
